import { IconTypes, UI, HStack, Stack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

import { HighlightedInfos } from '../HighlightedInfos';
import { InfoItemProps } from '../InfoItem';
import { ProductCard } from '../ProductCard';

export interface RedemptionCustomCardProps {
  iconType: 'success' | 'waiting';
  title: string;
  infos: InfoItemProps[];
  infoNote?: string;
  onSecondaryButtonPress?: () => void;
  onPrimaryButtonPress?: () => void;
}

export interface RedemptionIconProps {
  name: IconTypes.Props['name'];
  color: IconTypes.Props['color'];
}

export const RedemptionCustomCard: React.FC<RedemptionCustomCardProps> = ({
  iconType,
  infos,
  infoNote,
  onSecondaryButtonPress,
  onPrimaryButtonPress,
  title,
}) => {
  const getIconProps = (): RedemptionIconProps => {
    switch (iconType) {
      case 'success':
        return {
          name: 'Success',
          color: Color['feedback.success.default'],
        };
      case 'waiting':
        return {
          name: 'Time',
          color: Color['feedback.attention.default'],
        };
    }
  };

  return (
    <VStack space={Spacing['stack.xxxs']}>
      <ProductCard barColor="neutral.white">
        <VStack space={Spacing['stack.xxxs']} alignItems="center">
          <UI.Icon size="xl" {...getIconProps()} />
          <UI.Text variant="semibold" fontSize={Typography['fontsize.lg']}>
            {title}
          </UI.Text>
          <Stack w="full">
            <HighlightedInfos infos={infos} note={infoNote} />
          </Stack>
        </VStack>
      </ProductCard>
      <HStack alignSelf="end" space={Spacing['inline.xxxs']}>
        {onSecondaryButtonPress && (
          <UI.Button variant="secondary" onPress={onSecondaryButtonPress}>
            Acompanhar
          </UI.Button>
        )}
        {onPrimaryButtonPress && <UI.Button onPress={onPrimaryButtonPress}>NOVO RESGATE</UI.Button>}
      </HStack>
    </VStack>
  );
};
